import React from 'react'
import SpriteSvg from "../SpriteSvg/SpriteSvg"
import {Link} from "react-router-dom";
import './Logo.scss'


function Logo () {

  return (
    <div className='logo'>
      <SpriteSvg width='60' height='60' id='header-logo'/>
    </div>
  )
}

export default Logo